/**
 * CrisisLayer Class
 * @class CrisisLayer
 */

export default class CrisisLayer {
    slick;
    slider;
    constructor(item) {
        this.item = item;
        this.itemClosedClass = 'crisis-layer--close';
        this.closeBtn = item.querySelector('.attention-layer-close-button');
        this.loadEvents();
    }

    loadEvents() {
        this.closeBtn.addEventListener('click', () => {
            this.closeLayer();
        })
    }

    closeLayer() {
        this.item.classList.add(this.itemClosedClass);
    }
}
